import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/facilityservice');

export const regionsApiPaths = {
  /**
   * @deprecated
   */
  list: withRoot('/regions'),
  listV2: withRoot('/regions/v2'),
  regionById: withRoot('/regions/:regionId'),
  serviceRegions: withRoot('/regions/service-regions'),
} as const;

export const getRegionsApiUrl = {
  /**
   * @deprecated
   */
  list: () => regionsApiPaths.list,
  listV2: () => regionsApiPaths.listV2,
  regionById: (regionId: string) => replacePathParams(regionsApiPaths.regionById, { regionId }),
  serviceRegions: () => regionsApiPaths.serviceRegions,
};
